module.exports = __webpack_public_path__ + "static/media/arrow_left_grey.b438ad7a.svg";